import { defa } from 'defa-object';

import Model    from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	settingsAutomotive: apiHost + '/settingsautomotives',
	alarmGroup        : apiHost + '/settingsautomotives/%s/alarmgroup',
	removeAlarmGroup  : apiHost + '/settingsautomotives/%s/removealarmgroup',
};

/**
 * defa.models.SettingsAutomotive
 * The Model for the SettingsAutomotive
 * @version 1.2.1
 */
const SettingsAutomotive = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.settingsAutomotive,
	
	defaults: {
		type              : '',
		brand             : '',
		model             : '',
		registrationYear  : '',
		registrationNumber: '',
		chassisNumber     : '',
		color             : '',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Parses data from the backend before updating the model.
	 * @param  {object} response  The response from the backend.
	 * @return {object}           The parsed data from the backend.
	 * @overwrite
	 */
	parse: function ( response ) {
		
		channel.request( 'settingsAutomotives' ).add( response, { merge: true } );
		
		// if this is a first saved object, save the new id on the unit.
		if ( this.get( 'unit' ) ) {
			channel.request( 'units' ).add( {
				id                         : this.get( 'unit' ),
				transientSettingsAutomotive: response.id,
			}, {
				merge: true,
			} );
		}
		
		return response;
	},
	
	/**
	 * Combines brand and model and returns the combination as a name.
	 * @return {String}  This instance's name.
	 */
	name: function () {
		
		let html5 = this.get( 'brand' ) + ' ' + this.get( 'model' );
		return html5.trim();
	},
	
	// - save functions
	
	/**
	 * Save the alarm group option.
	 * @void
	 */
	saveAlarmGroup: function ( options ) {
		
		this.save( options, {
			url  : api.alarmGroup.replace( '%s', this.get( 'id' ) ),
			patch: true,
		} );
	},
	
	/**
	 * Save the alarm group option.
	 * @void
	 */
	removeAlarmGroup: function ( options ) {
		this.listenToOnce( this, 'sync', function () {
			this.set( 'alarmGroup', false );
		} );
		
		this.save( options, {
			url  : api.removeAlarmGroup.replace( '%s', this.get( 'id' ) ),
			patch: true,
		} );
	},
	
} );

export default SettingsAutomotive;